import { render, staticRenderFns } from "./AnswerState.vue?vue&type=template&id=6fc12e47&scoped=true&"
import script from "./AnswerState.vue?vue&type=script&lang=js&"
export * from "./AnswerState.vue?vue&type=script&lang=js&"
import style0 from "./AnswerState.vue?vue&type=style&index=0&id=6fc12e47&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc12e47",
  null
  
)

export default component.exports